/*@flow*/
// @ts-check
import { useState, useEffect } from 'react';

export function useHeight(containerRef, originalHeight) {
  const [metricsHeight, setMetricsHeight] = useState(600);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const containerHeight = el.offsetHeight;
    if (containerHeight === 0) return;
    const height = containerHeight - originalHeight;
    if (metricsHeight === height) return;
    if (height < 0) return;
    setMetricsHeight(height);
  }, [containerRef]);

  return metricsHeight;
}
